<template>
    <UserWrapper :extraWidth="false" :showTitleContainer="false">
      <template v-if="loading || !accessChecked">
        <Loader />
      </template>
      <div class="job-listing-container" v-else>
        <div class="notice-text p-2">
          試験的に導入している機能で、最初にキャリア登録した企業の求人のみ確認できます。今後、求人確認できる企業を順次増やします。
        </div>

        <!-- Toggle component using vue-js-toggle-button -->
        <div class="toggle-container p-2">
          <span class="toggle-label">マッチ求人表示</span>
          <toggle-button
            v-model="showMatchedJobs"
            :value="true"
            :sync="true"
            :labels="false"
            :width="50"
            :height="24"
            @change="handleToggleChange"
          />
        </div>

        <!-- Search component -->
        <div class="search-row p-2">
          <div class="search-label">フリーワード</div>
          <input
            type="text"
            class="search-input"
            v-model="searchKeyword"
            placeholder="複数ワードはスペース区切りで入力"
          />
          <button class="search-button" @click="handleSearch">
            検索
          </button>
        </div>
        <JobLists
          ref="jobLists"
          :showMatchedJobs="showMatchedJobs"
          :searchKeyword="searchKeyword"
          @search="handleSearch"
        />
      </div>
      <template v-slot:footer>
        <Footer/>
      </template>
    </UserWrapper>
</template>

<script>
import UserWrapper from "../UserWrapper.vue";
import JobLists from "./JobLists.vue";
import Loader from "../Loader.vue";
import Footer from "../Footer.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "JobListings",
  components: { UserWrapper, JobLists, Loader, Footer },
  data() {
    return {
      showMatchedJobs: true,
      searchKeyword: "",
      isClientSideSearch: true,
      loading: true,
      accessChecked: false,
    };
  },
  computed: {
    ...mapGetters({
      profile: "getProfile",
      isProfileLoaded: "getIsProfileLoaded",
    }),
  },
  methods: {
    ...mapActions({
      setProfile: "setProfile",
    }),
    handleToggleChange() {
      this.searchKeyword = "";
    },
    searchJobs() {
      // Implement search functionality
      console.log("Searching for:", this.searchKeyword);
      console.log("Show matched jobs only:", this.showMatchedJobs);
    },
    handleSearch() {
      this.$refs.jobLists.handleSearch();
    },
    async checkAccess() {
      try {
        if (!this.isProfileLoaded) {
          await this.setProfile();
        }

        const profile = this.profile;
        const hasAccess = Object.keys(profile).length > 0 && 
                        profile.has_scout_profile === true && 
                        profile.company_scout_profile === true;
        
        if (!hasAccess) {
          return this.$router.push('/');
        }
        this.accessChecked = true;
        // this.loading = false;
      } catch (error) {
        console.error('Failed to check access:', error);
        // this.loading = false;
        this.$router.push('/');  // Redirect on error
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.checkAccess();
  }
};
</script>

<style scoped>
>>> .profile-detail-block {
  background-color: #fff !important;
}
/* Notice text styles */
.notice-text {
  color: #ff0000;
  margin-bottom: 20px;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 400;
  padding: 0 px;
}

/* Toggle container styles */
.toggle-container {
  display: flex;
  align-items: center;
  /* margin-bottom: 20px; */
  font-size: 12px;
}

.toggle-label {
  margin-right: 10px;
}

.search-row {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.search-label {
  margin-right: 15px;
  min-width: 80px;
  white-space: nowrap;
  font-size: 12px;
}

.search-input-group {
  display: flex;
  font-size: 12px;
}

.search-input {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #d9d9d9;
  margin-right: 10px;
  font-size: 12px;
  width: 300px;
}
.search-input::placeholder {
  font-size: 12px;
  color: #666;
}

.search-button {
  padding: 8px 12px;
  background-color: #787878;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 12px;
  color: #fff;
}
</style>
